export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./recaptcha.vue?vue&type=template&id=0b16e825"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/recaptcha/recaptcha.vue?vue&type=template&id=0b16e825
// module id = LJAv
// module chunks = 0